// Error404.js
import React from 'react';
import { Link } from 'react-router-dom';
import LogoLoader from '../../assets/LogoLoader.svg';

const Error404 = () => {
  return (
    <div className="bg-black flex flex-col items-center justify-center min-h-screen px-4 text-center">
      <h1 className="font-extrabold text-secondary tracking-wide animate-pulse text-[28px] md:text-[50px] lg:text-[72px]">
        404
      </h1>
      <h2 className="font-semibold text-secondary mt-4 text-[26px] md:text-[48px]">
        Page Not Found
      </h2>
      <p className="mt-6 text-secondary max-w-xl text-[12px] md:text-[14px] lg:text-[16px]">
        Oops! It seems the page you're looking for doesn't exist.  
        For security reasons, some pages are restricted.
      </p>
      <p className="mt-4 text-gray-400 text-md text-[12px] md:text-[14px] lg:text-[16px]">
        Here are some helpful links instead:
      </p>

      <div className="mt-6 flex flex-col sm:flex-row gap-4">
        <Link to="/" className="text-primary hover:underline font-medium">
          Home
        </Link>
        <Link to="/aboutus" className="text-primary hover:underline font-medium">
          About Us
        </Link>
        <Link to="/services" className="text-primary hover:underline font-medium">
          Services
        </Link>
        <Link to="/contactus" className="text-primary hover:underline font-medium">
          Contact
        </Link>
        <Link to="/blog" className="text-primary hover:underline font-medium">
          Blog
        </Link>
      </div>

      <img
        src={LogoLoader}
        alt="404 Error"
        className="mt-12 w-1/2 max-w-xs sm:max-w-md animate-bounce"
      />
    </div>
  );
};

export default Error404;
